export default () => {
  const $documents = $('.documents');

  if ($documents.length === 0) {
    return;
  }

  const $controlsWrapper = $('.documents-controls');

  $documents.slick({
    infinite: true,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    pauseOnDotsHover: true,
    appendDots: $controlsWrapper,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          autoplay: false,
        },
      },
    ],
  });
};
